module.exports = __webpack_public_path__ + "img/norway-cardiovascular-diseases-female.ea5c69bb.png";